import { createSlice } from "@reduxjs/toolkit";
import undoable from "redux-undo";
import { CashflowCustomModelTypeEnum } from "api/admin/src";
export const initialState = {
    bypassUnsavedChangesPrompt: false,
    cashflowsState: [],
    cfModelCurrentState: {
        commitment: 10000000,
        type: CashflowCustomModelTypeEnum.Cashflows
    },
    isNameInvalid: false,
    validationMessage: []
};
const slice = createSlice({
    initialState,
    name: "cashflowModelReducers",
    reducers: {
        resetStateToDefault: (state) => {
            state.cfModelCurrentState = initialState.cfModelCurrentState;
            state.cashflowsState = [];
            state.bypassUnsavedChangesPrompt = false;
            delete state.actionType;
        },
        setActionType: (state, action) => {
            state.actionType = action.payload.actionType;
        },
        setBypassUnsavedChangesPrompt: (state, action) => {
            state.bypassUnsavedChangesPrompt = action.payload.bypassUnsavedChangesPrompt;
        },
        setModel: (state, action) => {
            state.cfModelCurrentState = action.payload;
            state.isNameInvalid = !action.payload.name;
        },
        setNameToInvalid: (state) => {
            state.isNameInvalid = true;
        },
        setNameToValid: (state) => {
            state.isNameInvalid = false;
        },
        setNewContribution: (state, action) => {
            state.cashflowsState[Number(action.payload.rowId)] = { ...state.cashflowsState[Number(action.payload.rowId)], contribution: Number(action.payload.newValue) };
        },
        setNewDescription: (state, action) => {
            state.cfModelCurrentState.description = action.payload.description;
        },
        setNewDistribution: (state, action) => {
            state.cashflowsState[Number(action.payload.rowId)] = { ...state.cashflowsState[Number(action.payload.rowId)], distribution: Number(action.payload.newValue) };
        },
        setNewName: (state, action) => {
            state.isNameInvalid = false;
            state.cfModelCurrentState.name = action.payload.name;
        },
        setNewNavPreview: (state, action) => {
            state.cashflowsState[Number(action.payload.rowId)] = { ...state.cashflowsState[Number(action.payload.rowId)], navPreview: Number(action.payload.newValue) };
        },
        setValidationMessage: (state, action) => {
            state.validationMessage = action.payload.validationMessage;
        },
        unSetActionType: (state) => {
            delete state.actionType;
        },
        unsetDescription: (state) => {
            delete state.cfModelCurrentState.description;
        },
        unsetName: (state, action) => {
            if (action.payload.invalid) {
                state.isNameInvalid = true;
            }
            delete state.cfModelCurrentState.name;
        }
    }
});
export const cashflowReducers = undoable(slice.reducer);
export const { resetStateToDefault, setNewName, setNewDescription, unsetDescription, unsetName, setNewContribution, setNewDistribution, setNewNavPreview, setNameToValid, setNameToInvalid, setModel, setValidationMessage, setBypassUnsavedChangesPrompt, setActionType, unSetActionType } = slice.actions;
